import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-cancel-exchange-confirmation',
  templateUrl: 'cancel-exchange-confirmation.html',
  styleUrls: ['cancel-exchange-confirmation.scss'],
})
export class CancelExchangeConfirmationComponent {
  @Input() isCancelConfirmation = true;
  @Input() dealNumber: string;
}
